export default "<div class=\"row\">\n  <div class=\"col-md-12 col-sm-12 col-lg-12 col-xl-12\">\n\n  </div>\n</div>\n\n\n"